import axiosInstance from "./AxiosInstance";
import qs from "qs";

class DelimitationService {
	constructor() {
		this.endpoint = "/api/delimitation";
	}

	async getDistricts() {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/national/districts`);
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}
	async getLocalDistricts() {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/local/districts`);
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}

	async getConstituenciesByDistrict(districtID) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/national/constituencies/district/${districtID}`);
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}
	async getCouncilsByDistrict(districtID) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/local/Council/${districtID}`);
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}

	async getPollingDivisionsByConstituency(constituencyID) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/national/pollingdivisions/constituency/${constituencyID}`);
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}

	async getRegistrationCentresByPollingDivision(pollingDivisionID) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/national/registrationcentres/pollingdivision/${pollingDivisionID}`);
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}

	async getRegistrationCentresByConstituency(constituencyID) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/local/registrationcentres/constituency/${constituencyID}`);
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}

	async getVillagesByRegistrationCentre(registrationCentreID, includeParentDemarcation) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/national/villages/registrationcentre/${registrationCentreID}`, {
				params: { includeParentDemarcation }
			});
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}

	async getLocalVillagesByRegistrationCentre(registrationCentreID, includeParentDemarcation) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/local/villages/registrationcentre/${registrationCentreID}`, {
				params: { includeParentDemarcation }
			});
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}
	async getVillagesByLocalRegistrationCentre(registrationCentreID) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/local/villages/registrationcentre/${registrationCentreID}`);
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}

	async GetLocalVotingDistrictsByCouncilIdAsync(councilID) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/local/votingdistrict/constituency/${councilID}`);
			return response.data;
		} catch (error) {
			console.error("Error fetkching data:", error);
			throw error;
		}
	}
	async GetLocalVotingStationByElectorDivisionIDAsync(electorDivisionId) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/local/votingstation/${electorDivisionId}`);
			return response.data;
		} catch (error) {
			console.error("Error fetkching data:", error);
			throw error;
		}
	}

	async getPollingStaionByNationalVotingStation(centreID) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/nation/PollingStations/${centreID}`);
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}
	async getPollingStaionByLocalVotingStation(centreID) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/local/PollingStations/${centreID}`);
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}
	async createPollingStations(data) {
		try {
			const response = await axiosInstance.post(`${this.endpoint}/create/polling/stations`, data);
			return response.data;
		} catch (error) {
			console.error("Error posting data:", error);
			throw error;
		}
	}

	async getNationalLocalDistrict(isNational = true) {
		return isNational ? this.getDistricts() : this.getLocalDistricts();
	}
	async getNationalLocalConstituency(isNational = true, value, isMultiSelectDemarcation = false) {
		if (isMultiSelectDemarcation) {
			return isNational ? this.getConstituenciesByMultipleDistricts(value) : this.getCouncilsByMultipleLocalDistricts(value);
		}
		return isNational ? this.getConstituenciesByDistrict(value) : this.getCouncilsByDistrict(value);
	}

	async getNationalLocalVotingDistrict(isNational = true, value, isMultiSelectDemarcation = false) {
		if (isMultiSelectDemarcation) {
			return isNational ? this.getPollingDivisionsByMultipleConstituencies(value) : this.GetLocalVotingDistrictsByMultipleCouncilsAsync(value);
		}
		return isNational ? this.getPollingDivisionsByConstituency(value) : this.GetLocalVotingDistrictsByCouncilIdAsync(value);
	}
	async getNationalLocalgetRegistrationCentres(isNational = true, value, isMultiSelectDemarcation = false) {
		if (isMultiSelectDemarcation) {
			return isNational
				? this.getRegistrationCentresByMultiplePollingDivisions(value)
				: this.GetLocalVotingStationByMultipleElectorDivisionsAsync(value);
		}
		return isNational ? this.getRegistrationCentresByPollingDivision(value) : this.GetLocalVotingStationByElectorDivisionIDAsync(value);
	}
	async getNationalLocalgetVillages(isNational = true, value, isMultiSelectDemarcation = false) {
		if (isMultiSelectDemarcation) {
			return this.getVillagesByMultipleRegistrationCentres(value, isNational);
		}
		return isNational ? this.getVillagesByRegistrationCentre(value) : this.getVillagesByLocalRegistrationCentre(value);
	}

	async createDermacation(data) {
		try {
			const response = await axiosInstance.post(`${this.endpoint}`, data);
			return response.data;
		} catch (error) {
			console.error("Error posting data:", error);
			throw error;
		}
	}

	async updateDermacation(data) {
		try {
			const response = await axiosInstance.put(`${this.endpoint}`, data);
			return response.data;
		} catch (error) {
			console.error("Error posting data:", error);
			throw error;
		}
	}

	async move(data) {
		try {
			const response = await axiosInstance.put(`${this.endpoint}/move`, data);
			return response.data;
		} catch (error) {
			console.error("Error posting data:", error);
			throw error;
		}
	}
	async deactive(data) {
		try {
			const response = await axiosInstance.put(`${this.endpoint}/activate`, data);
			return response.data;
		} catch (error) {
			console.error("Error posting data:", error);
			throw error;
		}
	}

	async getConstituenciesByMultipleDistricts(DistrictIDs) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/national/constituencies/district`, {
				params: {
					DistrictIDs
				},
				paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" })
			});
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}

	async getPollingDivisionsByMultipleConstituencies(constituencyIDs) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/national/pollingdivisions/constituency`, {
				params: {
					constituencyIDs
				},
				paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" })
			});
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}
	async getRegistrationCentresByMultiplePollingDivisions(pollingDivisionIDs) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/national/registrationcentres/pollingdivision`, {
				params: {
					pollingDivisionIDs
				},
				paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" })
			});
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}
	async getCouncilsByMultipleLocalDistricts(DistrictIDs) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/local/Council`, {
				params: {
					DistrictIDs
				},
				paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" })
			});
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}
	async GetLocalVotingDistrictsByMultipleCouncilsAsync(CouncilIDs) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/local/votingdistrict/constituency`, {
				params: {
					CouncilIDs
				},
				paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" })
			});
			return response.data;
		} catch (error) {
			console.error("Error fetkching data:", error);
			throw error;
		}
	}
	async GetLocalVotingStationByMultipleElectorDivisionsAsync(electorDividionIDs) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/local/votingstation`, {
				params: {
					electorDividionIDs
				},
				paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" })
			});
			return response.data;
		} catch (error) {
			console.error("Error fetkching data:", error);
			throw error;
		}
	}
	async getVillagesByMultipleRegistrationCentres(registrationCentreIDs, isNational) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/villages/registrationcentre`, {
				params: {
					registrationCentreIDs,
					isNational
				},
				paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" })
			});
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}
	async getNationalLocalgetPollingStations(isNational = true, value, EventID) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/pollingstation/registrationcentre`, {
				params: {
					RegistrationCentreID: value,
					IsNational: isNational,
					EventID
				}
			});
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}

	async getAllCorrections() {
    try {
        const response = await axiosInstance.get(`${this.endpoint}/correction`);
        return response.data;
    } catch (error) {
        console.error("Error fetching demarcation corrections:", error);
        throw error;
    }
}
	async CreateDemarcationCorrection(data) {
		try {
			const response = await axiosInstance.post(`${this.endpoint}/correction`, data);
			return response.data;
		} catch (error) {
			console.error("Error posting data:", error);
			throw error;
		}
	}

	async getCorrectionRecords(correctionID) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/correction/${correctionID}/records`);
			return response.data;
		} catch (error) {
			console.error("Error fetching correction records:", error);
			throw error;
		}
	}
	async getCorrectionDocument(documentID) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/correction/document/${documentID}`);
			return response.data;
		} catch (error) {
			console.error("Error fetching correction document:", error);
			throw error;
		}
	}
}

const delimitationService = new DelimitationService();

export { delimitationService };
